<template>
    <div>
        <v-container class="global-margin pb-0 mb-0 print-hide">
            <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
        </v-container>
        <v-container class="content-wrap print-hide pt-0 mt-0">
            <v-row>
                <v-col cols="12" class="mt-0 pt-0 pb-0 mb-0">
                    <v-container class="card-content flex-center flex-column pb-0 mb-0">
                        <div class="card-switch mt-5 flex-center hidden-xs-only">
                            <div v-for="(datum, i) in datumi" :key="i"
                                 :class="{'active-switch': datum.getTime() === currentDate.getTime() }"
                                 class="option-left flex-center"
                                 @click="changeDate(datum)">
                                <p class="ma-0 text-center w-100 text-capitalize">{{datum | moment("ddd, D.M.YYYY.")}}</p>
                            </div>
                        </div>
                        <div class="row card-switch-xs mt-5 mb-0 pb-0 flex-center hidden-sm-and-up"
                             v-for="(datum, i) in datumi"
                             :key="i"
                             @click="$vuetify.goTo('#razredi')">
                            <div :class="{'active-switch': datum.getTime() === currentDate.getTime()}"
                                 class="option-left flex-center"
                                 @click="changeDate(datum)">
                                <p class="ma-0 text-center w-100 text-capitalize">{{datum | moment("dddd, D.M.YYYY.")}}</p>
                            </div>
                        </div>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-row justify="center" align="center">
                <v-col cols="12" md="8">
                    <p class="print-hide">
                        Na platformi će se isporučivati osnovni raspored sati za sve škole uključene u projekt.<br/>
                        Digitalni materijali su pomoć nastavnicima koji <b>nemaju spremna online predavanja.</b><br/>
                        Ako nastavnik ima gotova svoja predavanja, njegovi učenici <b>ne moraju</b> pratiti sadržaj koji je isporučen, nego predmetni nastavnik u virtualnom razredu isporučuje sadržaj i aktivnost.<br/>
                        Virtualne razrede <b>ako želite</b> možete kreirati uz pomoć našega
                        <a href="/skolarac" target="_blank">školarca</a> ili <a href="/gsuite" target="_blank">Google G Suite rješenja.</a>
                        Hvala svima koji su uključeni u izradu nastavnih sadržaja. Na platformu se tjedno postavi preko 300 video lekcija.
                    </p>
                    <v-card flat="" class="mb-8 print-hide">
                        <v-row justify="center" align="center" class="pa-4">
                            <v-col cols="12" md="3">
                                <v-btn depressed
                                       rounded
                                       class="text-capitalize blue-text letter-spacing-none"
                                       v-clipboard:copy="hostUrl + '?datum=' + $moment(currentDate).format('D.M.YYYY.') "
                                       v-clipboard:success="onCopy"
                                       v-clipboard:error="onError"
                                >Kopiraj poveznicu</v-btn>
                            </v-col>
                            <v-col cols="12" md="5" class="text-end hidden-xs-only">
                                <span class="mt-2" style="color: #084776">Podijeli na društvenim mrežama:</span>
                            </v-col>
                            <v-col cols="12" md="5" class="hidden-sm-and-up">
                                <span class="mt-2" style="color: #084776">Podijeli na društvenim mrežama:</span>
                            </v-col>
                            <v-col cols="12" md="4">
                                <social-sharing
                                        :url="hostUrl + '?datum=' + $moment(currentDate).format('D.M.YYYY.')"
                                        inline-template>
                                    <div>

                                        <network network="facebook">
                                            <v-btn icon>
                                                <v-icon size="20" class>fab fa-facebook-f</v-icon>
                                            </v-btn>
                                        </network>
                                        <network network="googleplus">
                                            <v-btn icon>
                                                <v-icon size="20" class>fab fa-google-plus</v-icon>
                                            </v-btn>
                                        </network>
                                        <network network="linkedin">
                                            <v-btn icon>
                                                <v-icon size="20" class>fab fa-linkedin</v-icon>
                                            </v-btn>
                                        </network>
                                        <network network="twitter">
                                            <v-btn icon>
                                                <v-icon size="20" class>fab fa-twitter</v-icon>
                                            </v-btn>
                                        </network>
                                        <network network="whatsapp">
                                            <v-btn icon>
                                                <v-icon size="20" class>fab fa-whatsapp</v-icon>
                                            </v-btn>
                                        </network>
                                        <network network="viber">
                                            <v-btn icon>
                                                <v-icon size="20" class>fab fa-viber</v-icon>
                                            </v-btn>
                                        </network>
                                    </div>
                                </social-sharing>
                            </v-col>
                        </v-row>
                    </v-card>
                    <div id="raspored" class="flex-between mb-4">
                        <h2 class="headline" v-if="currentDate">
                            Nastava na daljinu, raspored za <span class="text-capitalize">{{currentDate | moment('dddd, D.M.YYYY.')}}</span>
                        </h2>
                        <v-icon class="print-hide" @click="printSchedule">print</v-icon>
                    </div>
                </v-col>
            </v-row>
            <v-row id="razredi" justify="center" align="center">
                <v-col cols="12" md="8">
                    <v-expansion-panels multiple focusable flat hover v-model="activePanel">
                        <template v-for="(item, i) in schedule" v-if="item.grade !== 10">
                            <v-expansion-panel :id="'raspored' + i" :key="i">
                                <v-expansion-panel-header
                                        class="blue-text font-weight-medium py-7 text-uppercase">
                                    {{item.grade}}. razred
                                    <template v-if="item.high_school === 1">&nbsp;SŠ</template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="py-5 pb-0">
                                    <div v-if="item.schedule.length" class="print-hide">
                                        <v-row align="center">
                                            <v-col cols="12" md="3">
                                                <v-btn
                                                        depressed
                                                        rounded
                                                        class="text-capitalize blue-text"
                                                        v-clipboard:copy="hostUrl + item.id + '?datum=' + $moment(currentDate).format('D.M.YYYY.') "
                                                        v-clipboard:success="onCopy"
                                                        v-clipboard:error="onError"
                                                >Kopiraj poveznicu</v-btn>
                                            </v-col>
                                            <v-col cols="12" md="5" class="text-end hidden-xs-only">
                                                <span class="mt-2" style="color: #084776">Podijeli na društvenim mrežama:</span>
                                            </v-col>
                                            <v-col cols="12" md="5" class="hidden-sm-and-up">
                                                <span class="mt-2" style="color: #084776">Podijeli na društvenim mrežama:</span>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <social-sharing
                                                        :url="hostUrl + item.grade + '?datum=' + $moment(currentDate).format('D.M.YYYY.')"
                                                        inline-template>
                                                    <div>

                                                        <network network="facebook">
                                                            <v-btn icon>
                                                                <v-icon size="20" class>fab fa-facebook-f</v-icon>
                                                            </v-btn>
                                                        </network>
                                                        <network network="googleplus">
                                                            <v-btn icon>
                                                                <v-icon size="20" class>fab fa-google-plus</v-icon>
                                                            </v-btn>
                                                        </network>
                                                        <network network="linkedin">
                                                            <v-btn icon>
                                                                <v-icon size="20" class>fab fa-linkedin</v-icon>
                                                            </v-btn>
                                                        </network>
                                                        <network network="twitter">
                                                            <v-btn icon>
                                                                <v-icon size="20" class>fab fa-twitter</v-icon>
                                                            </v-btn>
                                                        </network>
                                                        <network network="whatsapp">
                                                            <v-btn icon>
                                                                <v-icon size="20" class>fab fa-whatsapp</v-icon>
                                                            </v-btn>
                                                        </network>
                                                        <network network="viber">
                                                            <v-btn icon>
                                                                <v-icon size="20" class>fab fa-viber</v-icon>
                                                            </v-btn>
                                                        </network>
                                                    </div>
                                                </social-sharing>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <v-simple-table v-if="item.schedule.length">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">Sat</th>
                                                <th class="text-left">Predmet</th>
                                                <th class="text-left">Nastavna jedinica</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(stavka, j) in item.schedule" :key="j">
                                                <td>{{ j+1 }}</td>
                                                <td>{{ stavka.subject }}</td>
                                                <td>
                                                    <router-link
                                                            v-for="lekcija in stavka.lessons"
                                                            :to="'/lekcije/' + lekcija.lesson_id"
                                                            style="color: #084776"
                                                            class="d-block my-1"
                                                            :key="lekcija.lesson"
                                                    >{{lekcija.lesson}}</router-link>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <a v-else-if="item.grade < 6 && item.high_school == 0 && ![0,6].includes(currentDate.getDay())"
                                       class="text-decoration-none"
                                       href="/sumtv">
                                        <v-alert icon="tv"
                                                 prominent
                                                 class="v-card--hover"
                                                 text
                                                 type="info">
                                            Pratite od 10:00 na RTV Herceg Bosne ili putem SUM TV
                                        </v-alert>
                                    </a>
                                    <v-alert v-else
                                             text
                                             color="red"
                                             border="left"
                                             class="w-100 pl-7 mt-3">
                                        Raspored za ovaj razred trenutno nije dostupan!
                                    </v-alert>
                                    <v-alert v-if="item.grade == 4 && item.high_school == 1"
                                             text
                                             prominent=""
                                             type="info"
                                             border="left"
                                             icon="fas fa-info"
                                             class="w-100 pl-7 mt-4">
                                        <v-row class="ma-0 pa-0" align="center">
                                            <v-col class="grow">
                                                Besplatni tečaj za maturante
                                            </v-col>
                                            <v-col class="shrink">
                                                <v-btn rounded outlined depressed="" color="info" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdC2Nnu6XOl3fkuZ6pN5NiYIqsiZJX4rfqBHJeMyvkvV0VMBw/viewform" class="text-capitalize">Prijava</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-alert>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <!-- TODO: Fix break >
                            <div class="print-break"></div-->
                        </template>
                    </v-expansion-panels>
                </v-col>
                <v-col cols="12" md="8" class="text-center">
                    <v-menu v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn rounded
                                   readonly
                                   v-on="on"
                                   depressed color="#094776"
                                   class="text-capitalize white-text font-weight-medium prijava"
                            >Arhiva rasporeda</v-btn>
                        </template>
                        <v-date-picker
                                first-day-of-week="1"
                                locale="hr"
                                color="#084776"
                                v-model="archiveDate"
                                @input="searchArchive"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name: "Raspored",
        data() {
            return {
                hostUrl: location.protocol + '//' + location.host + '/raspored/',
                schedule: [],
                currentDate: null,
                datumi: [],
                dateOptions: { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' },
                activePanel: [],
                menu: false,
                archiveDate: new Date().toISOString().substr(0,10),
                breadcrumbs: [
                    {
                        text: 'Naslovnica',
                        disabled: false,
                        to: '/'
                    },
                    {
                        text: 'Raspored',
                        disabled: true,
                    },
                ]
            };
        },
        created() {
            // Todo: first day of this week
            this.currentDate = new Date();

            // Set next monday if sat/sun
            let day = this.currentDate.getDay();
            if([0,6].includes(day)) {
                this.currentDate.setDate(this.currentDate.getDate() + (day === 0 ? 1:2));
            }

            if (this.$route.query.datum) {
                this.currentDate = this.$moment(this.$route.query.datum, 'D.M.YYYY.').toDate();
            }

            this.currentDate.setHours(0,0,0,0);

            this.generateWeek();
        },
        methods: {
            changeDate(newDate) {
                this.currentDate = newDate;
                this.getSchedule();
            },
            getSchedule() {
                skoleApi.get("raspored", {
                    params: {
                        'datum': this.currentDate.toDateString()
                    }
                }).then(response => {
                    this.schedule = response.data;
                }).finally(() => {
                    if (this.$route.params.razred) {
                        this.activePanel = [];
                        this.activePanel.push(this.getClassIndex());
                    }
                });
            },
            getClassIndex() {
                return this.schedule.findIndex(item => {
                    return item.id == this.$route.params.razred
                });
            },
            generateWeek() {
                this.datumi = [];

                for (let i = 0; i < 5; i++) {
                    let current = this.getMonday();
                    current.setHours(0,0,0,0);
                    current.setDate(current.getDate() + i);
                    this.datumi.push(current);
                }

                this.getSchedule();
            },
            getMonday() {
                let newDate = new Date(this.currentDate.getTime());
                var day = newDate.getDay();
                var diff = newDate.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
                return new Date(newDate.setDate(diff));
            },
            onCopy: function(e) {
                alert("You just copied: " + e.text);
            },
            onError: function(e) {
                alert("Failed to copy texts");
            },
            printSchedule() {
                this.activePanel = [...this.schedule.filter(item => {
                    return item.high_school === 0;
                }).keys()];
                setTimeout(()=> {
                    window.print()
                }, 1300)
            },
            searchArchive() {
                this.menu = false;
                this.currentDate = new Date(this.archiveDate);
                this.currentDate.setHours(0,0,0,0);
                this.$vuetify.goTo('#raspored', {offset: 50});
                this.generateWeek();
            }
        },
        watch: {
            activePanel: function (newVal) {
                if (newVal && newVal.length > 0)
                    this.$vuetify.goTo('#raspored' + newVal[newVal.length - 1])
            }
        }
    };
</script>
<style lang="scss" scoped>
    .raspored {
        margin-top: 150px;
    }
    @media (max-width: 768px) {
        .lekcije {
            margin-top: 120px !important;
        }
    }
    .v-alert__wrapper {
        width: 100% !important;
    }
    .card-content {
        width: 100%;
        height: 80%;
        .card-switch {
            width: 100%;
            height: 56px;
            background-color: #ffffff;
            border-radius: 33px;

            .option-left,
            .option-right {
                width: 50%;
                height: 100%;
                border-radius: 33px;
                cursor: pointer;
            }
        }
    }

    .card-content {
        width: 100%;
        height: 80%;
        .card-switch-xs {
            width: 100%;
            height: 56px;
            background-color: #ffffff;
            border-radius: 33px;

            .option-left,
            .option-right {
                width: 100%;
                height: 100%;
                border-radius: 33px;
                cursor: pointer;
            }
        }
    }

    .class-item {
        border: 1px solid #dee7ea;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        transition: 0.3s ease;
        cursor: pointer;
        &:hover {
            border: 1px solid #094776;
            transition: 0.3s ease;
        }
    }
    .moodle-btn {
        letter-spacing: 0 !important;
        border-radius: 30px;
    }
    @media (max-width: 768px) {
        .alert-wrap {
            div {
                align-items: flex-start;
                flex-direction: column;
                p {
                    margin-top: 20px;
                    margin-bottom: 20px !important;
                }
            }
            flex-direction: column !important;
            button {
                margin-top: 20px;
            }
        }
        .card-switch {
            width: 100% !important;
        }
    }
    .active-switch {
        background-color: #094776 !important;
        p {
            color: #fff !important;
        }
    }
</style>
